import PortalIdParser from 'PortalIdParser';
import Playbooks from 'in-meeting-experience-ui-components/components/playbooks/Playbooks/Playbooks';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { routes } from '../constants/routes';
import { searchObject } from '../data/api/crmV3Api';
import { fetchPlaybooks, fetchRecommendedPlaybooks } from '../data/api/playbooksApi';
import useTracker from '../hooks/useTracker';
import { callObjectIdSelector } from '../slices/callObject/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
function PlaybooksComponent() {
  const callObjectId = useSelector(callObjectIdSelector);
  const usageTracker = useTracker();
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PLAYBOOKS_PAGE_LOADED",
    children: /*#__PURE__*/_jsx(Playbooks, {
      portalId: PortalIdParser.getPortalIdFromPath(),
      callObjectId: Number(callObjectId),
      featureTipsLink: "",
      apiWrapper: {
        playbooks: {
          fetchPlaybooks,
          fetchRecommendedPlaybooks
        },
        searchObject
      },
      usageTracker: usageTracker,
      reconnectRoute: routes.reconnect
    })
  });
}
export default PlaybooksComponent;